import { action, payload } from 'ts-action';

import { TogglePopupType } from './types';

import { NoticeOrErrorModel } from '../../models/notice.error.model';

export const TARGET_ID_MODAL = 'react-simple-modal-container';

export const UI = '[UI]';
export const TOGGLE_POPUP = `${UI} Popup toggle`;
export const SET_LOADER = `${UI} Set loader`;
export const SET_ERROR = `${UI} Set error`;
export const SET_NOTICE = `${UI} Set notice`;
export const SET_ERRORS = `${UI} Set errors`;
export const SET_NOTICES = `${UI} Set notices`;
export const CLEARED_ERRORS = `${UI} Cleared errors`;
export const CLEARED_NOTICES = `${UI} Cleared notices`;
export const SET_SUCCESS = `${UI} Set success`;
export const SET_URL_HISTORY = `${UI} Set url history`;

export const setLoader = action(SET_LOADER, payload<Record<string, boolean>>());

export const setError = action(SET_ERROR, payload<Record<string, unknown | string>>());

export const setNotice = action(SET_NOTICE, payload<Record<string, unknown | string>>());

export const setErrors = action(SET_ERRORS, payload<NoticeOrErrorModel[]>());

export const setNotices = action(SET_NOTICES, payload<NoticeOrErrorModel[]>());

export const clearErrors = action(CLEARED_ERRORS, payload<string | undefined>());

export const clearNotices = action(CLEARED_NOTICES, payload<string | undefined>());

export const setSuccess = action(SET_SUCCESS, payload<Record<string, boolean>>());

export const togglePopup = action(TOGGLE_POPUP, payload<TogglePopupType>());

export const setUrlHistory = action(SET_URL_HISTORY, payload<string>());
